import React, { PureComponent } from 'react';

export default class FormHeader extends PureComponent {

render(){
  return <div className="flex justify-flex-end">
    <div onClick={e => this.props.onClick(e)} className="cursor-pointer"><u>None</u></div>&nbsp;&nbsp;&nbsp;&nbsp;
    <div onClick={e => this.props.onClick(e, 'all_can_read')}  className="blue-text cursor-pointer"><u>View</u></div>&nbsp;&nbsp;&nbsp;&nbsp;
    <div onClick={e => this.props.onClick(e, 'all_can_update')}  className="red-text cursor-pointer"><u>Edit</u></div>
  </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/userPlanPermissionTable/formHeader.js